import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const BannerMasterList = () => {
  const [bannerData, setBannerData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_banner"
      );
      setBannerData(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    const formData = new FormData();
    formData.append("banner_id", userId);

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_banner",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Delete response:", response.data);

      if (response.data.status === true || response.data.status === "true") {
        setBannerData((prevUser) =>
          prevUser.filter((user) => user.banner_id !== userId)
        );
        toast.error(response.data.message || "Data Deleted Successfully!");
        navigate("/Banner");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete category.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Banner List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="#">Banner</Link>
                </li>
                <li className="breadcrumb-item active">Banner List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table View */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center gap-1">
                <h4 className="card-title flex-grow-1">All Banner List</h4>
                <Link to="/Banner-add" className="btn btn-sm btn-primary">
                  Add Banner
                </Link>
              </div>
              <div className="table-responsive">
                <table className="table align-middle mb-0 table-hover table-centered">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th>#</th>
                      <th>Banner Image</th>
                      <th>Heading</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bannerData.length > 0 ? (
                      bannerData.map((banner, index) => (
                        <tr key={banner.banner_id}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                              <img
                                src={`https://cyberathon.com/multivendor/${banner.banner_image}`}
                                alt={banner.banner_heading || "Banner"}
                                className="avatar-md"
                              />
                            </div>
                          </td>
                          <td>
                            <p className="text-dark fw-medium fs-15 mb-0">
                              {banner.banner_heading}
                            </p>
                          </td>
                          {/* <td>
                            <span
                              className={`badge ${
                                banner.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {banner.status}
                            </span>
                          </td> */}
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/Banner-view/${banner.banner_id}`}
                                className="btn btn-light btn-sm"
                              >
                                <i className="fa-solid fa-eye align-middle fs-18"></i>
                              </Link>
                              <Link
                                to={`/Banner-edit/${banner.banner_id}`}
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil align-middle fs-18"></i>
                              </Link>
                              <span
                                  onClick={() => deleteUser(banner.banner_id)}
                                  className="btn btn-soft-danger btn-sm"
                                >
                                  <i class="fa-solid fa-trash align-middle fs-18"></i>
                                </span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No banners found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* Pagination */}
              <div className="card-footer border-top">
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Previous
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        2
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Next
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BannerMasterList;
